import { usePageMutationCreator } from 'ui-model';

export const usePostLumaBotReschedulerReminder = () =>
  usePageMutationCreator({
    key: 'usePostLumaBotReschedulerReminder',
    url: 'lumabotPage/reminder',
    method: 'POST',
    params: {},
  });
